import { render, staticRenderFns } from "./CmsLifecycleStateBadge.vue?vue&type=template&id=efa0c778&scoped=true&"
import script from "./CmsLifecycleStateBadge.vue?vue&type=script&lang=js&"
export * from "./CmsLifecycleStateBadge.vue?vue&type=script&lang=js&"
import style0 from "./CmsLifecycleStateBadge.vue?vue&type=style&index=0&id=efa0c778&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa0c778",
  null
  
)

export default component.exports